export default "__VITE_ASSET__o1pDUcik__"